"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineConditionalFieldMap = exports.postProcessAsset = void 0;
const lodash_1 = require("lodash");
const postProcessAsset = (conditionalFields) => {
    return (data) => {
        for (const key of Object.keys(conditionalFields)) {
            const renderCondition = conditionalFields[key];
            if (renderCondition && !renderCondition(data)) {
                const thisKeysData = (0, lodash_1.get)(data, key);
                if (!Array.isArray(thisKeysData) || thisKeysData.length > 0) {
                    (0, lodash_1.unset)(data, key);
                }
            }
        }
        return data;
    };
};
exports.postProcessAsset = postProcessAsset;
const combineConditionalFieldMap = (...conditionalFields) => {
    return conditionalFields.reduce((acc, curr) => {
        return { ...acc, ...curr };
    }, {});
};
exports.combineConditionalFieldMap = combineConditionalFieldMap;
//# sourceMappingURL=renderingConditions.js.map